import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';
import userPropTypes from '../../../userPropTypes.js';

function generateData({ partner, user }) {
    if (user.verificationStatus === 'NOT_VERIFIED') {
        return {
            actionRequiredType: 'NEGATIVE',
            content: 'Bekreft identitet',
            statusSummary:
                'Du må bekrefte din identitet før kjøper kan betale.',
        };
    }

    return {
        actionRequiredType: 'POSITIVE',
        content: (
            <div>
                <p className="man">Venter på betaling fra {partner.name}.</p>
            </div>
        ),
        statusSummary: 'Du har godkjent avtalen.',
    };
}

const AgreementAcceptedSummary = ({ partner, user }) => {
    const { actionRequiredType, content, statusSummary } = generateData({
        partner,
        user,
    });
    return (
        <StatusSummaryButton
            href="/avtale-godkjent"
            statusSummary={statusSummary}
            actionRequiredType={actionRequiredType}
        >
            {content}
        </StatusSummaryButton>
    );
};

AgreementAcceptedSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
    user: userPropTypes.isRequired,
};

export default AgreementAcceptedSummary;



// WEBPACK FOOTER //
// ./safeTrade/seller/agreement/summaries/agreementAcceptedSummary.jsx